export default "__VITE_ASSET__4f5ed5b1__"